import React from 'react';

import { MissionControlStaffingTableJobsBase } from './_mission-control-staffing-table-jobs-base';

export function MissionControlStaffingTableReviewsPending() {
  return <MissionControlStaffingTableJobsBase tableKind="reviews_pending" />;
}
